export default __webpack_public_path__ + "static/media/receipts-list.43e10945.png";